import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useAuthFetch } from '~/composables/useAuthFetch'
import { useAuthClient } from '~/utils/auth-client'

/**
 * Middleware de autenticación usando Better Auth
 *
 * Usa useAuthFetch para SSR: llama al API absoluto y reenvía Cookie.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path === '/login') {
    return
  }

  try {
    const authClient = useAuthClient()
    const { data: session, error } = await authClient.useSession(useAuthFetch)

    if (error.value || !session.value) {
      return navigateTo({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } catch (err) {
    console.error('Error en middleware de autenticación:', err)
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})
